import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import LatestNewsList from '@/pages/home/components/LatestNewsList';
import PopularWorks from '@/pages/home/components/PopularWorks';
import ProfileSummary from '@/pages/home/components/ProfileSummary';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-100 flex flex-col">
      <Navbar />

      <main className="flex-1 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-6 md:py-10">
        <h1 className="sr-only">张柏芝最新资讯</h1>

        <section className="mb-8 md:mb-10">
          <HeroCarousel />
        </section>

        <section className="mb-8 md:mb-10">
          <CategoryEntries />
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-2 flex flex-col gap-5 md:gap-6">
            <LatestNewsList />
            <PopularWorks />
          </div>
          <div className="flex flex-col gap-5 md:gap-6">
            <ProfileSummary />

            <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-bold text-primary-900 mb-2">专题推荐</h3>
              <p className="text-sm text-primary-800 leading-relaxed mb-4">
                回顾张柏芝演艺生涯中的经典时刻，精选深度专题持续更新中。
              </p>
              <Link
                to="/specials"
                className="cursor-pointer whitespace-nowrap inline-flex items-center gap-1 text-sm font-label text-accent-600 hover:text-accent-700"
              >
                进入专题合集
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}